import { render, staticRenderFns } from "./AutoCdrCall.vue?vue&type=template&id=6ec9821c&scoped=true&"
import script from "./AutoCdrCall.vue?vue&type=script&lang=js&"
export * from "./AutoCdrCall.vue?vue&type=script&lang=js&"
import style0 from "./AutoCdrCall.vue?vue&type=style&index=0&id=6ec9821c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9821c",
  null
  
)

export default component.exports